"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSoftFontColor = exports.MAX_OFFSET_ON_LIGHT = exports.MAX_OFFSET_ON_DARK = void 0;
var meetsContrast_1 = require("../utils/meetsContrast");
var NominalContrasts_1 = require("../utils/NominalContrasts");
exports.MAX_OFFSET_ON_DARK = 15;
exports.MAX_OFFSET_ON_LIGHT = 70;
function getSoftFontColor(fontBase, blockColorSwatches, blockShades) {
    var nominalContrastIndex = blockShades.isDark
        ? NominalContrasts_1.NominalContrasts[exports.MAX_OFFSET_ON_DARK]
        : NominalContrasts_1.NominalContrasts[exports.MAX_OFFSET_ON_LIGHT];
    var limit = blockShades.isDark ? nominalContrastIndex - 3 : nominalContrastIndex + 3;
    var softFontCandidate = fontBase;
    var step = blockShades.isDark ? -1 : 1;
    for (var index = nominalContrastIndex; index * step <= limit * step; index += step) {
        softFontCandidate = blockColorSwatches[index].generatedColor;
        if ((0, meetsContrast_1.meetsContrastWithBlockShades)(softFontCandidate, blockShades)) {
            return softFontCandidate;
        }
    }
    return softFontCandidate;
}
exports.getSoftFontColor = getSoftFontColor;
//# sourceMappingURL=getSoftFontColor.js.map